import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { sharedStyles } from '../../shared/styles';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Checkbox from '@mui/material/Checkbox';

const SignoffSummaryDialog = ({ open, onClose, summary, onSubmit}) => {
    const sharedClasses = sharedStyles();
    const classes = useStyles();
    const [userSummary, setUserSummary] = useState(summary);
    const [approved, setApproved] = useState(false);
    useEffect(()=>{setUserSummary(summary)}, [summary])
    return (
        <Dialog
            maxWidth={'md'}
            open={open}
            onClose={({...rest})=>{
                onClose()
            }}
            aria-labelledby="form-dialog-title"
            scroll={"paper"}
            classes={{ paper: classes.dialogPaper }}

        >
            <DialogTitle>
                    Consultation Summary
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {
                        summary ?
                        'Please review the below AI-generated summary of this consult and then click "Submit".'
                        :
                        'Please provide a summary of this consult and then click "Submit".'
                    }
                </DialogContentText>
                <TextField
                    defaultValue={summary}
                    onChange={(e) => setUserSummary(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    id="summary"
                    multiline={true}
                    rows={10}
                    placeholder={"Summary"}
                    fullWidth
                />
                <div style={{display: 'flex', flexDirection: 'row', fontSize: '0.75rem', alignItems: 'center'}}>
                    <Checkbox
                        id="approved_summary"
                        checked={approved}
                        onChange={(event) => setApproved(event.target.checked)}
                        css={{backgroundColor: 'blue'}}
                        disabled={!userSummary||(userSummary??'').length === 0}
                        required
                    />
                    <div>I acknowledge that I have reviewed the summary above. I understand that the content of this summary is final and cannot be edited.</div>
                </div>
            </DialogContent>
            <DialogActions>
              <Button disabled={!approved} color="primary" onClick={()=>{
                  onSubmit(userSummary)}} variant="contained">Submit</Button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minWidth: '40vw',
    },
}));

export default SignoffSummaryDialog;
